import { format } from 'date-fns'

import { DATE_FULL_FORMAT_FROM_TIME } from '../../../../../constants/date'
import { toUkTimezoneDate } from '../../../../../utils/date'

export function formatCalendarTaskMoveDeadline({ deadline, timezone }) {
  return format(
    toUkTimezoneDate(deadline, timezone),
    DATE_FULL_FORMAT_FROM_TIME
  )
}
